import AuthenticatedRoute from './AuthenticatedRoute';

export default AuthenticatedRoute;
